// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2D6Tf","container":"styles_container__nlYjj"};